import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { RadiologistCutoff } from "./useRadiologistCutoffs";
import { formatMinutes } from "./timeFormatUtils";

type Status = "available" | "unavailable" | "cutoff_time";

const BG_COLORS: Record<Status, string> = {
  available: "#388e3c",
  unavailable: "#d32f2f",
  cutoff_time: "#f57c00",
};

type Props = {
  cutoff?: RadiologistCutoff;
};

const CutoffStatusChip: FC<Props> = ({ cutoff }) => {
  let status: Status = "available";
  let label = "Available";

  if (cutoff?.type === "unavailable") {
    status = "unavailable";
    label = "Unavailable";
  } else if (
    cutoff?.type === "cutoff_time" &&
    cutoff.cutoffMinutesFromMidnight !== null
  ) {
    status = "cutoff_time";
    label = `Cutoff: ${formatMinutes(cutoff.cutoffMinutesFromMidnight)}`;
  }

  return (
    <Box
      sx={{
        bgcolor: BG_COLORS[status],
        borderRadius: 1,
        px: 1.5,
        py: 0.75,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: "common.white", whiteSpace: "nowrap" }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CutoffStatusChip;
